import mixins from '@synergycms_core/less/mixins';

export default {
  header: {},
  closeButton: {},
  titleListBlock: {},
  tabTitle: {},
  inputBox: {
    width: '100%',
    padding: '0',
    boxSizing: 'border-box',
    position: 'relative',
    display: 'block',
    '& input:-webkit-autofill': {
      boxShadow: '0 0 0 1000px #fff inset'
    },
    '& input:-moz-autofill:focus': {
      boxShadow: '0 0 0 1000px #fff inset'
    },
    '& $inputText': {
      width: 'calc( 100% - 90px )',
      backgroundColor: '#ffffff',
      padding: '16px 25px 5px 10px',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      '&:lang(ar)': {
        paddingLeft: "5px",
        paddingRight: "10px"
      }
    },
    '& $labelText': {
      position: 'absolute',
      top: '12px',
      left: '15px',
      zIndex: '0',
      color: '#8d8d8d',
      right: '10px',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      font: '13px Roboto, sans-serif',
      ...mixins.transition("top .3s"),
      '&:lang(ar)': {
        left: "auto",
        right: "15px"
      }
    },
    '& $inputText:focus, & $inputText:not([value=""])': {
      '& ~ $labelText': {
        top: '4px'
      }
    },
    '& $disabled': {
      background: '#bbb',
      border: '1px solid #bbb',
      color: '#fff'
    },
    '& $sendCustomerMailButton': {
      background: data => data.mainColor,
      width: 'auto',
      padding: '0 10px',
      position: 'absolute',
      height: '40px',
      bottom: '5px',
      right: '0',
      top: '0',
      font: '13px Roboto, sans-serif',
      border: '1px solid #5ca70a',
      borderColor: data => data.mainColor,
      '&:lang(ar)': {
        left: "0",
        right: "auto"
      },
      '&:hover': {
        background: 'transparent',
        color: data => data.mainColor,
        WebkitTransition: '.3s',
        OTransition: '.3s',
        transition: '.3s'
      }
    },
    '& > span': {
      '& invalid': {
        top: '50px !important',
      }
    }
  },
  sendMailContainer:{},
  contentBlock: {},
  customerMailBlock: {
    '& $inputText:-webkit-autofill, & $inputText:-webkit-autofill:hover, & $inputText:-webkit-autofill:focus': {
      boxShadow: '0 0 0 1000px #fff inset',
      WebkitTextFillColor: '#000',
      transition: 'background-color 9999s ease-in-out 0s'
    },
    '& $inputText:-moz-autofill:focus': {
      boxShadow: '0 0 0 1000px #fff inset'
    },
    '&$shortSummary':{
      '& $textModal':{
        float: 'inline-start',
        marginLeft:'12px',
        '&:before': {
          position: 'absolute',
          top: '25px',
        },
      },
    }
  },
  inputText: {},
  labelText: {},
  disabled: {},
  acquaintanceMailBlock: {},
  submitButtonsBox: {},
  dismissMailButton: {},
  sendMailButton: {},
  sendCustomerMailButton: {},
  reservationInfoBlock: {},
  infoRow: {},
  infoCell: {},
  infoCellRight: {},
  paxNumberCell: {},
  paxBlock: {},
  last: {},
  childContainer: {},
  validIcon:{},
  textModal:{},
  validInput:{
    marginTop:'-25px'
  },
  sendMailContent: {
    '&:lang(ar)': {
      direction: "rtl"
    },
    backgroundColor: '#f1f1f1',
    '& $header': {
      padding: '15px 35px 15px 15px',
      fontWeight: '500',
      fontSize: '16px',
      color: '#000',
      position: 'relative',
      textAlign: 'left',
      borderBottom: '1px solid #d8d8d8',
      '& $closeButton': {
        position: 'absolute',
        top: '50%',
        right: '10px',
        height: '24px',
        width: '24px',
        marginTop: '-12px',
        color: data => data.mainColor,
        fontSize: '16px',
        border: '0',
        background: 'transparent',
        "&:lang(ar)": {
          right: "auto",
          left: "10px"
        }
      },
      "&:lang(ar)": {
        textAlign: "right"
      }
    },
    '& $titleListBlock': {
      extend: mixins.boxShadow('0 5px 7px -5px rgba(0,0,0,.3)'),
      display: 'table',
      width: '100%',
      textAlign: 'center',
      borderSpacing: '15px 0px',
      padding: '0',
      margin: '0',
      '@global li': {
        marginBottom: '0',
        marginLeft: '5px',
        display: 'table-cell',
        verticalAlign: 'middle',
        position: 'relative'
      },
      '& $tabTitle': {
        padding: '15px 0',
        width: '100%',
        position: 'relative',
        '@global > span': {
          textTransform: 'uppercase',
          font: data => '400 13px ' + data.fontFamily1
        }
      }
    },
    '& $inputBox': {
      width: '100%',
      padding: '0 11px 11px',
      position: 'relative',
      display: 'block',
      boxSizing: 'border-box',
      '&:before': {
        content: 'none'
      }
    },
    '& $contentBlock': {
      extend: mixins.clearFix(),
      padding: '20px 0',
      display: 'block',
      borderBottom: '1px solid #d8d8d8',
      '& $customerMailBlock': {
        backgroundColor: '#f1f1f1',
        boxSizing: 'border-box',
        padding: '0 20px 0 16px',
        '&:lang(ar)': {
          paddingRight: "16px",
          paddingLeft: "20px"
        },
        '& $validIcon':{
          '& :before':{
            right:'96px',
            marginTop:'0',
          }
        }
      },
      '& $acquaintanceMailBlock': {
        backgroundColor: '#f1f1f1',
        '& $inputBox': {
          width: '100%',
          padding: '0 11px 11px',
          position: 'relative',
          display: 'block',
          boxSizing: 'border-box',
          '& $inputText': {
            width: '100%',
            backgroundColor: '#ffffff',
            padding: '16px 5px 5px 13px',
            font: "13px 'Roboto'",
            "&:lang(ar)": {
              paddingRight: "13px",
              paddingLeft: "5px",
            }
          },
          '& $labelText': {
            position: 'absolute',
            top: '12px',
            left: '25px',
            zIndex: '0',
            color: '#8d8d8d',
            right: '10px',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            font: '13px Roboto, sans-serif',
            ...mixins.transition("top .3s"),
            '&:lang(ar)': {
              left: "auto",
              right: "25px"
            }
          },
          '& $inputText:focus, & $inputText:not([value=""])': {
            '& ~ $labelText': {
              top: '4px'
            }
          }
        },
        '& $submitButtonsBox': {
          width: '100%',
          padding: '0 11px 11px',
          position: 'relative',
          display: 'block',
          boxSizing: 'border-box',
          '@global label': {
            paddingLeft: '0',
            display: 'inline',
            '&:before': {
              content: 'none'
            }
          },
          '& $dismissMailButton': {
            width: '47%',
            height: '40px',
            padding: '0',
            position: 'relative',
            font: '13px Roboto, sans-serif'
          },
          '& $sendMailButton': {
            background: '#5ca70a',
            width: '47%',
            position: 'relative',
            font: '13px Roboto, sans-serif',
            right: '5px',
            float: 'right',
            border: '1px solid #5ca70a',
            '&:hover': {
              background: 'transparent',
              color: '#5ca70a',
              WebkitTransition: '.3s',
              OTransition: '.3s',
              transition: '.3s'
            },
            '&:lang(ar)': {
              float: "left",
              right: "auto",
              left: "5px"
            }
          }
        },
        '&:last-of-type': {
          borderBottom: 'none',
          paddingBottom: '0'
        }
      }
    },
    '& $reservationInfoBlock': {
      borderBottom: '1px solid #d8d8d8',
      padding: '15px 13px',
      display: 'table',
      width: '100%',
      boxSizing: 'border-box',
      '& $infoRow': {
        display: 'table-row',
        textAlign: 'left',
        "&:lang(ar)": {
          textAlign: "right",
        },
        '& $infoCell': {
          display: 'table-cell',
          padding: '3px 0'
        },
        '& $infoCellRight': {
          textAlign: 'left',
          paddingLeft: '10px',
          lineHeight: '1.85',
          '& > span': {
            '& > span:first-of-type': {
              marginRight: '5px',
              verticalAlign: 'bottom',
              "&:lang(ar)": {
                marginRight: "0",
                marginLeft: "5px",
                '& roboto13Black':{
                  marginRight: '5px',
                }
              }
            }
          },
          "&:lang(ar)": {
            textAlign: "right",
          }
        },
        '& $paxNumberCell': {
          textAlign: 'right',
          display: 'table-cell',
          '&:lang(ar)': {
            textAlign: "left"
          }
        },
        '& $paxBlock': {
          font: "300 13px 'Roboto', sans-serif",
          '&:lang(ar)': {
            display: 'flex',
            '& > span': {
              display: 'flex',
              alignItems: 'center',
              '& > span':{
                '&:last-of-type': {
                  marginRight: '5px',
                }
              }
            }
          }
        }
      },
      '&$last': {
        border: 'none'
      }
    },
    '& $childContainer': {
      position: 'relative',
      marginLeft: '10px',
      paddingLeft: '10px',
      '&:before': {
        content: '"|"',
        position: 'absolute',
        left: '0',
        top: '50%',
        lineHeight: '0',
        fontSize: '14px',
        fontFamily: 'Roboto, sans-serif',
        color: '#000'
      },
      "&:lang(ar)": {
        marginLeft: "0",
        marginRight: "10px",
        paddingLeft: "0",
        paddingRight: "10px",
        "&:before": {
          left: "auto",
          right: "0"
        }
      }
    },
    '@media (min-width: 801px)': {
      margin: '0 10px'
    }
  },
  sendContainer: {
    '@global > button': {
      margin: '0',
      font: "13px 'Roboto', sans-serif",
    }
  },
  shortSummary:{
    float:'none',
    '& $inputBox':{
      textAlign:'right',
      cursor: 'default',
    },
    '& $inputText':{
      boxShadow:'none',
      width:'100%',
      paddingLeft:'12px',
      marginBottom:'0 !important'
    },
    '& $inputText:focus, & $inputText:not([value=""])': {
      '& ~ $labelText': {
        top: '-8px'
      }
    },
    '& $labelText':{
      textAlign:'left',
      fontSize:'13px',
      fontWeight:300,
      lineHeight:'17.5px',
      display:'inline-block',
      background:'#fff',
      right:'auto',
      left:'9px',
      padding:'0 3px'
    },
    '& $sendCustomerMailButton':{
      position:'static',
      fontSize:'15px',
      fontWeight:500,
      lineHeight:'17.5px',
      marginTop:'10px',
      '&:disabled':{
        background: '#B2B2B2',
        borderColor:'#B2B2B2',
        '&:hover':{
          color:'#fff',
        }
      },
      '@media (min-width: 801px)': {
        marginTop:'12px'
      }
    }
  }
};
